var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTimer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#8B8B8B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M6.144 11.396a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#8B8B8B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M6.144 3.396v3l2 1"
})));
export { SvgTimer as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuMTQ0MjkgMTEuMzk2MkM4LjkwNTcxIDExLjM5NjIgMTEuMTQ0MyA5LjE1NzY2IDExLjE0NDMgNi4zOTYyNEMxMS4xNDQzIDMuNjM0ODIgOC45MDU3MSAxLjM5NjI0IDYuMTQ0MjkgMS4zOTYyNEMzLjM4Mjg2IDEuMzk2MjQgMS4xNDQyOSAzLjYzNDgyIDEuMTQ0MjkgNi4zOTYyNEMxLjE0NDI5IDkuMTU3NjYgMy4zODI4NiAxMS4zOTYyIDYuMTQ0MjkgMTEuMzk2MloiIHN0cm9rZT0iIzhCOEI4QiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik02LjE0NDI5IDMuMzk2MjRWNi4zOTYyNEw4LjE0NDI5IDcuMzk2MjQiIHN0cm9rZT0iIzhCOEI4QiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";